// @ts-nocheck FIXME
import React from 'react';

class ArtifactCommentV2 extends React.Component {
  render() {
    const authorRole = this.props.is_coach ? 'BetterLesson Coach' : 'Teacher';
    return (
      <div className="portfolio-v2__artifact-comment">
        <div className="portfolio-v2__artifact-comment-text">
          {this.props.data}
        </div>
        <div className="portfolio-v2__artifact-comment-author">
          &mdash; {this.props.first_name}&nbsp;{this.props.last_name},{' '}
          {authorRole}
        </div>
      </div>
    );
  }
}

export default ArtifactCommentV2;
